//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum } from './Enums';

export class CalendarRepertoireEventDisplayItem extends ItemBase {
    Color: EventColorEnum = EventColorEnum.Beach;
    EventTitle: string | null = null;
    Date: string = "1970-01-01T00:00:00";

    constructor(initializer?: Partial<CalendarRepertoireEventDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarRepertoireEventDisplayItem";
}
